<template>
    <CardRh :processando="processando" titulo="Disciplinas Cadastradas">
        <div class="disciplina-index-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span> 
                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="pesquisaDisciplina" class="form-label">Pesquisar</label>
                        <input id="pesquisaDisciplina" v-model="search" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Pesquisar" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="turmaDisciplina" class="form-label">Turma</label>
                        <input id="turmaDisciplina" v-model="turma" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Turma" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2" v-if="tipos">
                        <label for="tipoDisciplina" class="form-label">Tipo</label>
                        <Multiselect id="tipoDisciplina" @change="refreshTable" :options="tipos_select"
                            :searchable="true" v-model="tipo_id" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2" v-if="status">
                        <label for="statusDisciplina" class="form-label">Status</label>
                        <Multiselect id="statusDisciplina" @change="refreshTable" :options="status_select"
                            :searchable="true" v-model="status_id" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="somatorioDisciplina" class="form-label">Somatorio</label>
                        <Multiselect id="somatorioDisciplina" @change="refreshTable" :options="somatorio_select"
                            :searchable="true" v-model="isSomatorio" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="cpfInstrutorDisciplina" class="form-label">CPF Instrutor</label>
                        <input id="cpfInstrutorDisciplina" v-model="cpfInstrutor" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="CPF do instrutor" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="cargaHorariaMinDisciplina" class="form-label">C.H. Minima</label>
                        <input id="cargaHorariaMinDisciplina" v-model="cargaHorariaMin" @keyup="apertouEnter"
                            type="number" class="form-control form-control-solid" placeholder="Minima" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="cargaHorariaMaxDisciplina" class="form-label">C.H. Maxima</label>
                        <input id="cargaHorariaMaxDisciplina" v-model="cargaHorariaMax" @keyup="apertouEnter"
                            type="number" class="form-control form-control-solid" placeholder="Maxima" />
                    </div> 
                    
                    <div class="col-12 col-lg-2 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm mt-5" @click="limparFiltros">
                            Limpar
                        </button>
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada()"
                    :pesquisar="false">
                    <th style="max-width: 90px">ID</th>
                    <th>Disciplina</th>
                    <th>Turma</th>
                    <th>Turma</th>
                    <th>C.H.</th>
                    <th>Forma de Avaliacao</th>
                    <th>Peso</th>
                    <th style="min-width: 220px" class="text-center" v-if="hasPermissao">Acoes</th>
                </KDataTable>
            </section>
        </div>
    </CardRh>
</template>

<script lang="ts">
import IndexModelTable from "@/views/paginas/sigap/modelos/IndexModelTable.vue";
import CardRh from "@/components/cards/ManzaCard.vue";
import DisciplinaService from "@/service/v1/sigap/DisciplinaService";
import { Options } from "vue-class-component";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";

@Options({
    name: "DisciplinaIndex",
    components: { CardRh, KDataTable, Multiselect },
})
export default class DisciplinaIndex extends IndexModelTable {
    public tipo_id: any = null;
    public tipos: any = null;
    public status_id: any = null;
    public status: any = null;
    public turma = ""; 
    public cpfInstrutor = "";
    public cargaHorariaMin: any = null;
    public cargaHorariaMax: any = null;
    public isSomatorio: any = null;
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get tipos_select() {
        if (this.tipos) {
            return this.tipos.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    get somatorio_select() {
        return [
            { value: "true", label: "Sim" },
            { value: "false", label: "Nao" },
        ];
    }

    public getDisciplinaTipo() {
        this.processando = true;
        this.service.getDisciplinaTipo()
            .then(response => {
                this.tipos = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.turma = ""; 
        this.tipo_id = null;
        this.status_id = null;
        this.cpfInstrutor = "";
        this.cargaHorariaMin = null;
        this.cargaHorariaMax = null;
        this.isSomatorio = null;
        this.refreshTable();
    }

    created() {
        this.service = new DisciplinaService();
        this.getDisciplinaTipo();
        this.getStatus();
        this.config.order = [[3, "desc"],[1, "asc"]];
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => { 
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    turma: this.turma, 
                    tipo: this.tipo_id,
                    status: this.status_id,
                    cpfInstrutor: this.cpfInstrutor,
                    cargaHorariaMin: this.cargaHorariaMin,
                    cargaHorariaMax: this.cargaHorariaMax,
                    isSomatorio: this.isSomatorio,
                    search: this.search || d.search.value, 
                };
                return dados;
            }
        };

        this.config.columns = [
            { data: "id", name: "id" },
            { data: "descricao", name: "descricao" },
            { data: "turma.descricao", name: "turma" },
            { data: "turma.descricao", name: "turmainicio",class: "never" },
            { data: "cargaHoraria", name: "cargahoraria" },
            { data: "tipo.nome", name: "tipo" },
            { data: "peso", name: "peso" },
        ];

        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs = [
                {
                    targets: 7,
                    render: (row, type, val) => {
                        let texto = "";
                        let buttom = "";
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';
                        return texto;
                    },
                },
            ];
        }
    }

    public tableatualizada() {
        $("[btn-show]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            this.$router.push({ name: "sigap_disciplina_show", params: { id: id } });
        });
    }
}
</script>

<style scoped>
.disciplina-index-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
    padding: 0.55rem 1.25rem;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
